import { IProgramFilter, IProgramFilterFormatted } from '../context/ProgramContext';

export function formatProgramFilter(programFilter: IProgramFilter): IProgramFilterFormatted {
  return {
    tag_ids: programFilter.tags ? programFilter.tags.map((s) => Number(s.id)).filter(Boolean) : undefined,
    skill_ids: programFilter.skills ? programFilter.skills.map((s) => Number(s.id)).filter(Boolean) : undefined,
  };
}